import React, { useContext } from 'react';

import JSONMapContext from './json_map.jsx';

const ErasContext = React.createContext();

function ErasProvider({ children }) {
	const { get_eras, set_eras } = useContext(JSONMapContext);
	const eras = get_eras();

	const store = {
		get list() {
			return eras;
		},

		async set(eras) {
			await set_eras(eras);
		},
	};

	return <ErasContext.Provider value={store}>{children}</ErasContext.Provider>;
}

export default ErasContext;
export { ErasProvider };

